import { Component, EventEmitter, Input } from '@angular/core';
import { Notification } from '@api/models/notification';

@Component({
    selector: 'app-notification-content',
    templateUrl: './notification-content.component.html',
    standalone: false
})
export class NotificationContentComponent {
  @Input() notification: Notification;
  @Input() redirect: EventEmitter<void>;
}
